(() => {
  if (customElements.get('polygons-bottle')) return;
  class PolygonsBottle extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const source = this.querySelector('[data-bottle-data]');
      if (!source) return;
      try { this.data = JSON.parse(source.textContent); } catch { return; }
      this.initialized = true;
      this.form = this.querySelector('form');
      this.select = this.querySelector('[data-bottle-select]');
      this.quantity = this.querySelector('[data-bottle-quantity]');
      this.addButton = this.querySelector('[data-bottle-add]');
      this.media = [...this.querySelectorAll('[data-bottle-media]')];
      this.thumbs = [...this.querySelectorAll('[data-bottle-thumb]')];
      this.currentMedia = Math.max(0, this.media.findIndex(item => !item.hidden));
      this.currentVariant = this.data.variants.find(item => String(item.id) === String(this.select.value)) || this.data.variants[0];
      this.querySelector('[data-bottle-swatches]').hidden = false;
      this.querySelector('[data-bottle-native]').hidden = true;
      this.querySelectorAll('[data-bottle-minus], [data-bottle-plus]').forEach(button => button.hidden = false);
      this.addEventListener('click', event => this.onClick(event));
      this.select.addEventListener('change', () => this.chooseVariant(this.select.value));
      this.quantity.addEventListener('change', () => this.clampQuantity());
      this.form.addEventListener('submit', event => this.addToCart(event));
      this.clampQuantity();
    }
    onClick(event) {
      const variant = event.target.closest('[data-bottle-variant]');
      const thumb = event.target.closest('[data-bottle-thumb]');
      if (variant) this.chooseVariant(variant.dataset.bottleVariant);
      else if (thumb) this.showMedia(this.media.findIndex(item => item.dataset.bottleMedia === thumb.dataset.bottleThumb));
      else if (event.target.closest('[data-bottle-prev]')) this.showMedia(this.currentMedia - 1);
      else if (event.target.closest('[data-bottle-next]')) this.showMedia(this.currentMedia + 1);
      else if (event.target.closest('[data-bottle-minus]')) { this.quantity.value = Number(this.quantity.value) - 1; this.clampQuantity(); }
      else if (event.target.closest('[data-bottle-plus]')) { this.quantity.value = Number(this.quantity.value) + 1; this.clampQuantity(); }
    }
    showMedia(index) {
      if (!this.media.length) return;
      const next = (index + this.media.length) % this.media.length;
      this.media.forEach((item, position) => {
        item.hidden = position !== next;
        if (item.hidden) item.querySelectorAll('video').forEach(video => video.pause());
      });
      this.thumbs.forEach((item, position) => item.setAttribute('aria-pressed', String(position === next)));
      this.currentMedia = next;
      const thumb = this.thumbs[next];
      if (thumb) thumb.parentElement.scrollTo({ left: thumb.offsetLeft - thumb.parentElement.offsetLeft - thumb.parentElement.clientWidth / 2 + thumb.clientWidth / 2, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    chooseVariant(id) {
      const variant = this.data.variants.find(item => String(item.id) === String(id));
      if (!variant || this.busy) return;
      this.currentVariant = variant;
      this.select.value = String(variant.id);
      this.querySelector('[data-bottle-color]').textContent = variant.title;
      this.querySelector('[data-bottle-price]').innerHTML = variant.price;
      const compare = this.querySelector('[data-bottle-compare]');
      compare.innerHTML = variant.compareAtPrice;
      compare.hidden = !variant.onSale;
      this.querySelectorAll('[data-bottle-variant]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.bottleVariant === String(variant.id))));
      this.querySelector('[data-bottle-availability]').dataset.available = String(variant.available);
      this.querySelector('[data-bottle-availability-title]').textContent = variant.available ? this.data.strings.available : this.data.strings.soldOut;
      this.querySelector('[data-bottle-availability-note]').textContent = variant.available ? this.data.strings.availabilityNote : this.data.strings.soldOutNote;
      this.addButton.disabled = !variant.available;
      this.querySelector('[data-bottle-add-label]').textContent = variant.available ? this.data.strings.add : this.data.strings.soldOut;
      this.querySelector('[data-bottle-success]').hidden = true;
      this.querySelector('[data-bottle-error]').hidden = true;
      const mediaIndex = this.media.findIndex(item => item.dataset.bottleMedia === String(variant.mediaId));
      if (mediaIndex >= 0) this.showMedia(mediaIndex);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    }
    clampQuantity() {
      const value = Math.round(Number(this.quantity.value));
      this.quantity.value = String(Math.min(99, Math.max(1, Number.isFinite(value) ? value : 1)));
      this.querySelector('[data-bottle-minus]').disabled = Number(this.quantity.value) <= 1;
      this.querySelector('[data-bottle-plus]').disabled = Number(this.quantity.value) >= 99;
    }
    async addToCart(event) {
      event.preventDefault();
      if (this.busy || !this.currentVariant?.available) return;
      this.clampQuantity();
      const error = this.querySelector('[data-bottle-error]');
      const success = this.querySelector('[data-bottle-success]');
      error.hidden = true;
      success.hidden = true;
      this.busy = true;
      this.addButton.disabled = true;
      this.addButton.setAttribute('aria-busy', 'true');
      this.querySelector('[data-bottle-add-label]').textContent = this.data.strings.adding;
      try {
        const response = await fetch(this.data.cartAddUrl, { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(this.form) });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : this.data.strings.error);
        success.hidden = false;
        this.dispatchEvent(new CustomEvent('polygons:cart-added', { bubbles: true, detail: { items: result.items || [result] } }));
        try {
          const cartResponse = await fetch(`${this.data.cartUrl}.js`, { headers: { 'Accept': 'application/json' } });
          if (cartResponse.ok) { const cart = await cartResponse.json(); document.querySelectorAll('[data-cart-count]').forEach(count => { count.textContent = cart.item_count; count.hidden = !cart.item_count; count.classList.toggle('has-items', cart.item_count > 0); }); }
        } catch {}
      } catch (failure) {
        error.textContent = failure.message || this.data.strings.error;
        error.hidden = false;
      } finally {
        this.busy = false;
        this.addButton.disabled = !this.currentVariant.available;
        this.addButton.removeAttribute('aria-busy');
        this.querySelector('[data-bottle-add-label]').textContent = this.currentVariant.available ? this.data.strings.add : this.data.strings.soldOut;
      }
    }
  }
  customElements.define('polygons-bottle', PolygonsBottle);
})();
